// GA4 event tracking for key commerce interactions.
// gtag is loaded globally via theme.liquid — this module wires DOM events to it.

declare function gtag(...args: unknown[]): void

function track(name: string, params: Record<string, unknown> = {}): void {
  if (typeof gtag !== 'function') return
  gtag('event', name, params)
}

function buildItem(form: HTMLElement): Record<string, unknown> {
  const title = document.querySelector<HTMLElement>('.main-product__title')?.textContent?.trim() ?? ''
  const variantInput = form.querySelector<HTMLInputElement>('[data-pdp-variant-input]')
  const priceEl = form.querySelector<HTMLElement>('[data-pdp-price]')
  const price = priceEl?.textContent?.replace(/[^0-9.]/g, '') ?? '0'
  return {
    item_id: variantInput?.value ?? '',
    item_name: title,
    price: parseFloat(price),
    currency: (window as any).Shopify?.currency?.active ?? 'USD',
  }
}

export function initAnalytics(): void {
  // Add to Cart
  const pdpForm = document.querySelector<HTMLFormElement>('#pdp-form')
  pdpForm?.addEventListener('submit', () => {
    track('add_to_cart', {
      currency: (window as any).Shopify?.currency?.active ?? 'USD',
      items: [buildItem(pdpForm)],
    })
  })

  // Variant switch
  document.querySelectorAll<HTMLButtonElement>('[data-pdp-option] button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const optionLabel = btn.closest('[data-pdp-option]')
        ?.querySelector('[id^="pdp-option"]')?.textContent?.trim() ?? 'option'
      track('select_item', {
        item_list_name: optionLabel,
        items: [{ item_name: document.querySelector('.main-product__title')?.textContent?.trim() ?? '', item_variant: btn.dataset.value }],
      })
    })
  })

  // Try-on open
  document.querySelector('[data-tryon-open]')?.addEventListener('click', () => {
    track('virtual_try_on_open', {
      item_name: document.querySelector('.main-product__title')?.textContent?.trim() ?? '',
    })
  })

  // Notify me submit
  document.querySelector<HTMLFormElement>('#pdp-notify-form')?.addEventListener('submit', () => {
    track('notify_me_submit', {
      item_name: document.querySelector('.main-product__title')?.textContent?.trim() ?? '',
    })
  })

  // Cart updated → track view_cart equivalent
  window.addEventListener('meera:cart:updated', (evt) => {
    track('cart_updated', { item_count: evt.detail?.itemCount ?? 0 })
  })
}
